import React from 'react';
import ProductLandingPage from './ProductLandingPage';

export default function AiAutomationsLandingPage() {
  return (
    <ProductLandingPage
      title="AI automations"
      description="AI employees that connect to your tools and take repetitive work off the team."
      bullets={[
        'Automation opportunities by role, with time-back estimates.',
        'Playbooks that compound revenue instead of adding headcount.',
        'Same workspace as grants and vendor savings.',
      ]}
      ctaTo="/sign-up"
      ctaLabel="Start on getupgraded.ai"
    />
  );
}
